import api from "./api";

const URL_PREFIX = '/books/';

class BooksService {
  getBooks(search = '', page = 1, limit = 20) {
    const params = { search, page, limit };
    return api.get(URL_PREFIX + "getBooks", { params });
  }

  getBooksByPodcast(podcastId, page = 1, limit = 20) {
    const params = { podcastId, page, limit };
    return api.get(URL_PREFIX + "getBooksByPodcast", { params });
  }

  getEpisodes(podcastId, page = 1, limit = 10) {
    const params = { podcastId, page, limit };
    return api.get(URL_PREFIX + "getEpisodesByPodcast", { params });
  }

  getAllEpisodes(podcastId) {
    const params = { podcastId, page: 1, limit: 1000 };
    return api.get(URL_PREFIX + "getEpisodesByPodcast", { params });
  }

  getBookBySlug(slug) {
    return api.get(URL_PREFIX + "slug/" + slug);
  }

  getDashboardBooks() {
    return api.get(URL_PREFIX + "dashboard");
  }

  updateBookLinks(id, link, link_en, image) {
    return api.put(URL_PREFIX + id + "/links", { link, link_en, image });
  }

  getTopBooks2025() {
    return api.get(URL_PREFIX + "top-2025");
  }

  getBookTweets(page = 1, limit = 50) {
    const params = { page, limit };
    return api.get(URL_PREFIX + "tweets", { params });
  }
}

const booksServiceInstance = new BooksService();

export default booksServiceInstance;